"use client";

import { cn } from "@/lib/utils";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const classNames = props.toastOptions?.classNames;

  return (
    <Sonner
      className="pointer-events-auto"
      theme={"light"}
      {...props}
      toastOptions={{
        ...props.toastOptions,
        classNames: {
          ...classNames,
          toast: cn(classNames?.toast, "relative pr-10!"),
          closeButton: "toast-close-button-custom",
        },
      }}
    />
  );
};

export { Toaster };
